import React from 'react';
import ContactForm from '../components/Contact/ContactForm';
import Footer from '../components/Footer';
import WhyChooseUs from '../components/WhyChooseUs';
import WhatWeOffer from '../components/WhatWeOffer';
import Location from '../components/Contact/Location';

function Contact() {
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				gap: '50px',
				marginTop: '70px',
			}}
		>
			<ContactForm />
			<Location />
			<WhyChooseUs />
			<WhatWeOffer />
			<Footer />
		</div>
	);
}

export default Contact;
